<template>
  <div>
    <div class="row m-0">
      <div class="col-12 pl-md-3 my-3">
        <h3>Privacy Policy</h3>
      </div>
      <div class="col-12 pl-3 my-3">
        <div class="row m-0">
          <div class="col-12 p-0 mb-3">
            <p><b>READ THIS POLICY CAREFULLY BEFORE BROWSING THIS APPLICATION OR USING ANY OF OUR SERVICES. YOUR CONTINUED USE OF THIS APPLICATION AND OUR SERVICES INDICATES THAT YOU HAVE BOTH READ AND AGREE TO THE TERMS OF THIS PRIVACY POLICY. YOU CANNOT USE THIS APPLICATION OR OUR SERVICES IF YOU DO NOT ACCEPT THIS POLICY. ALL SECTIONS OF THIS POLICY ARE APPLICABLE TO USERS UNLESS THE SECTION EXPLICITLY STATES OTHERWISE.</b></p>
<p><a href="https://modelonline.co.za/#/" target="_blank">Modelonline.co.za</a> is the website of Model Bottle Store and Wine Cellar (Pty) Ltd, based in Pierneef Boulevard, Meyerton, Gauteng South Africa.</p>
<p>In adopting this Privacy Policy we wish to balance our legitimate business interests and your reasonable expectation of privacy. Accordingly, we will take all reasonable steps to prevent unauthorised access to or disclosure of your personal information although this is impossible to guarantee. </p>
<p>In utilising our application, users may be asked to disclose name, telephone number and delivery address but your agreement to this Privacy Policy constitutes your consent as envisaged in Section 69 of the Act. </p>
<p>We store your personal information directly. It will only be accessed by our employees. This information will only be shared on a need-to-know basis. </p>
<p>We use cookies. A cookie is a small piece of information stored on your computer or smartphone. </p>
<p>The services available through this website may contain links to third party websites. We do not monitor and control third party websites and if you follow the link you may be subjected to their terms and conditions. </p>
<p><b>Application of the Electronic Communications and Transactions Act 25 of 2005 (Ect Act.)</b></p>
<p>Data Messages as defined by the Act will be deemed to have been received by us if and when we respond to the data message.</p>
<p>Data messages sent by us to a user will be deemed to be received by a user in terms of the provisions specified in Section23(b) of the Ect Act.</p>
<p>Users acknowledge that electronic signatures encryption and/or authentication are not required for valid electronic communications between us and users.</p>
<p>This application is owned and operated by <a href="https://modelonline.co.za/#/" target="_blank">modelonline.co.za</a>.</p>
<p>Lodging of Complaints</p>
<p>We only process your personal information in compliance with this Privacy Policy and in accordance with relevant data protection laws. If however you wish to raise a complaint regarding the processing of your personal information or you are dissatisfied with how we have handled your personal information you have a right to lodge a complaint with the Information regulator: <a href="tel:+270100235207" target="_blank">+270100235207</a> or <a href="mailto:inforeg@justice.co.za" target="_blank">inforeg@justice.co.za</a>. </p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['position'],
  data () {
    return {
      loaderSize: '50px'
    }
  },
  metaInfo () {
    return {
      title: 'The Hoods - Home',
      meta: [
        { name: 'description', content: 'Shop local, online.' },
        {
          property: 'fb:app_id',
          content: '2744358572336800'
        },
        { property: 'og:title', content: 'The Hoods' },
        {
          property: 'og:description',
          content: 'Shop local, online.'
        },
        { property: 'og:type', content: 'website' },
        {
          property: 'og:image',
          content: '/thehoods_large.png/'
        },
        {
          property: 'og:url',
          content: 'https://thehoods.app/'
        }
      ]
    }
  }
}
</script>

<style>
.small_text {
  font-size: 0.8rem;
  line-height: 1;
}
.border_bottom {
  border-bottom: 1px solid var(--light-color-off);
}
.dark-mode .border_bottom {
  border-bottom: 1px solid var(--light-color-01);
}
.small_text .truncate {
    word-wrap: break-word;
    overflow-y: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    height: 2;
  }
.small_text .form-control {
  font-size: 0.8rem;
}
.category_menu {
  height: 50px;
  position: sticky;
  top: 80px;
  z-index: 9;
}
.bg_color {
  border-top: 1px solid var(--dark-color-off);
  margin-left: -1px;
}
.dark-mode .bg_color {
  border-top: 1px solid var(--light-color-off);
  border-left: 1px solid var(--dark-color-off)
}
.overflow_x  {
  overflow-x: auto;
}

@media (min-width: 768px) {
  .category_menu {
    top: 50px;
  }
  .sidebar_cart {
    position: sticky;
    top: 120px;
    z-index: 9;
    bottom: inherit;
    width: 100%;
    max-height: calc(100vh - 120px);
  }
}
</style>
